import React from 'react';
import { IconButton, Tooltip } from '@mui/material';

interface ActionProps {
    title:string, 
    onClick: () => void,
    icon: React.ReactElement
}

const Actions: React.FC<ActionProps> = ({ 
    title, 
    onClick,
    icon
}): React.JSX.Element => {
  return (
    <Tooltip title={title}>
        <IconButton onClick={onClick}>
            {icon}
        </IconButton>
    </Tooltip>
  );
};

export default Actions;
